/*
* blocktimes.js
*
* Description: Holds 'Stores' Logic for Module:'Blocktimes'.
*
* This file is part of: "http://apps.sundair.com/", "SunCrew2 - Flights"
* Copyright 2018,2019,2020,2021,2022 Sundair GmbH
* Contact: http://www.sundair.com/
* @author Christian Arp <christian.arp@sundair.com>
* @author Learek <michael.broeker@sundair.com>
* @author Phillip Alsleben <phillip.alsleben@sundair.com>
*
*/
import Vue from 'vue';
import axios from 'axios';
import { eventBus } from '../../../main';
import dayjs from 'dayjs';
import utc from 'dayjs/plugin/utc';
dayjs.extend(utc);


//-----------------------------------------------------------------------------/
// #
// #    /$$$$$$   /$$                /$$
// #   /$$__  $$ | $$               | $$
// #  | $$  \__//$$$$$$   /$$$$$$  /$$$$$$    /$$$$$$
// #  |  $$$$$$|_  $$_/  |____  $$|_  $$_/   /$$__  $$
// #   \____  $$ | $$     /$$$$$$$  | $$    | $$$$$$$$
// #   /$$  \ $$ | $$ /$$/$$__  $$  | $$ /$$| $$_____/
// #  |  $$$$$$/ |  $$$$/  $$$$$$$  |  $$$$/|  $$$$$$$
// #   \______/   \___/  \_______/   \___/   \_______/
// #
//-----------------------------------------------------------------------------/
const state = {

    // >>> blocktimes -------------------------------------
    blocktimes_blocktimes: [],
    blocktimes_blocktimes_Filtered: [],
    // >>> blocktimes - search/filter ---------------------
    blocktimes_filterTerm: {}

};




//-----------------------------------------------------------------------------/
// #
// #    /$$$$$$              /$$     /$$
// #   /$$__  $$            | $$    | $$
// #  | $$  \__/  /$$$$$$  /$$$$$$ /$$$$$$    /$$$$$$   /$$$$$$  /$$$$$$$
// #  | $$ /$$$$ /$$__  $$|_  $$_/|_  $$_/   /$$__  $$ /$$__  $$/$$_____/
// #  | $$|_  $$| $$$$$$$$  | $$    | $$    | $$$$$$$$| $$  \__/  $$$$$$
// #  | $$  \ $$| $$_____/  | $$ /$$| $$ /$$| $$_____/| $$      \____  $$
// #  |  $$$$$$/|  $$$$$$$  |  $$$$/|  $$$$/|  $$$$$$$| $$      /$$$$$$$/
// #   \______/  \_______/   \___/   \___/   \_______/|__/     |_______/
// #
//-----------------------------------------------------------------------------/
const getters = {

    /***************************************************************************
    * Getters: 'Blocktimes' -
    ***************************************************************************/
    /***************************************************************************
    * get_Blocktimes()
    *
    * Desc:
    * Note:
    *
    */
    get_Blocktimes: state => {

        return state.blocktimes_blocktimes;

    }, // eo function get_Blocktimes()


    /***************************************************************************
    * get_Blocktimes_Filtered()
    *
    * Desc:
    * Note:
    *
    */
    get_Blocktimes_Filtered: state => {

        return state.blocktimes_blocktimes_Filtered;

    } // eo function get_Blocktimes_Filtered()

};





//-----------------------------------------------------------------------------/
// #
// #   /$$      /$$             /$$                /$$
// #  | $$$    /$$$            | $$               | $$
// #  | $$$$  /$$$$ /$$   /$$ /$$$$$$   /$$$$$$  /$$$$$$    /$$$$$$
// #  | $$ $$/$$ $$| $$  | $$|_  $$_/  |____  $$|_  $$_/   /$$__  $$
// #  | $$  $$$| $$| $$  | $$  | $$     /$$$$$$$  | $$    | $$$$$$$$
// #  | $$\  $ | $$| $$  | $$  | $$ /$$/$$__  $$  | $$ /$$| $$_____/
// #  | $$ \/  | $$|  $$$$$$/  |  $$$$/  $$$$$$$  |  $$$$/|  $$$$$$$
// #  |__/     |__/ \______/    \___/  \_______/   \___/   \_______/
// #
//-----------------------------------------------------------------------------/
const mutations = {

    /***************************************************************************
    * Mutations: 'Blocktimes', Call: Get Blocktimes
    ***************************************************************************/
    /***************************************************************************
    * mut_call_getBlocktimes()
    *
    * Desc: Save 'Blocktimes' (unfiltered).
    * Note:
    *
    */
    mut_call_getBlocktimes: (state, payload) => {

        state.blocktimes_blocktimes = payload.payload; // save

        // >>> Rebuild ------------------------------------
        payload.context.commit('mut_filter_Blocktimes'); // rebuild

    }, // eo function mut_call_getBlocktimes()


    /***************************************************************************
    * Mutations: 'Blocktimes', Call: Create/Update Blocktimes
    ***************************************************************************/
    /***************************************************************************
    * mut_call_updateCreateBlocktimes()
    *
    * Desc: Save 'Blocktimes' (unfiltered).
    * Note: Is ID of payload currently used -> update case
    * Note: Otherwise -> create case
    *
    */
    mut_call_updateCreateBlocktimes: (state, payload) => {

        payload.payload.forEach((p) => {

            const isUpdateCase = state.blocktimes_blocktimes.some(blocktime => blocktime.id === p.id),
            blocktimes_blocktimesCopy = [];


            // >>> Update Case --------------------------------
            if (isUpdateCase === true) {
                state.blocktimes_blocktimes.forEach((item) => {
                    if (item.id === p.id) {
                        item = p; // 'overwrite'

                        item.wasEdited = true;
                    }
                    blocktimes_blocktimesCopy.push(item);
                });

                state.blocktimes_blocktimes = blocktimes_blocktimesCopy;
            }

            // >>> Create Case --------------------------------
            if (isUpdateCase === false) {
                state.blocktimes_blocktimes.push(p);
            }
        });



        // >>> Rebuild ------------------------------------
        payload.context.commit('mut_filter_Blocktimes'); // rebuild

    }, // eo function mut_call_updateCreateBlocktimes()


    /***************************************************************************
    * Mutations: 'Blocktimes', Call: Delete Blocktimes
    ***************************************************************************/
    /***************************************************************************
    * mut_call_deleteBlocktime()
    *
    * Desc: Delete Index from 'blocktimes_blocktimes_Filtered'.
    * Note: Delete in filtered AND in original resources list (blocktimes_blocktimes).
    *
    */
    mut_call_deleteBlocktime: (state, payload) => {

        const index_blocktimes_Filtered = state.blocktimes_blocktimes_Filtered.findIndex(i => i.id === payload.id),
            index_blocktimes_Blocktimes = state.blocktimes_blocktimes.findIndex(i => i.id === payload.id);


        if (index_blocktimes_Filtered > -1) {
            state.blocktimes_blocktimes_Filtered.splice(index_blocktimes_Filtered, 1);
        }

        if (index_blocktimes_Blocktimes > -1) {
            state.blocktimes_blocktimes.splice(index_blocktimes_Blocktimes, 1);
        }

    }, // eof mut_call_deleteBlocktime()




    /***************************************************************************
    * Actions: 'Blocktimes' - Search/Filter
    ***************************************************************************/
    /***************************************************************************
    * mut_set_filterBlocktimes_filterTerm()
    *
    * Desc: Simply set/save 'blocktimes_filterTerm'.
    * Note:
    *
    */
    mut_set_filterBlocktimes_filterTerm: (state, payload) => {

        state.blocktimes_filterTerm = payload; // save

    }, // eo function mut_set_filterBlocktimes_filterTerm()


    /***************************************************************************
    * mut_filter_Blocktimes()
    *
    * Desc: (Re)build 'new' 'blocktimes_blocktimes_Filtered'.
    * Note:
    *
    */
    mut_filter_Blocktimes: (state) => {

        // >>> 'filterDepartureAirport' -------------------------
        const filterDepartureAirport = (resource) => {
            let applyFilter = false;

            if (state.blocktimes_filterTerm.departureAirport && state.blocktimes_filterTerm.departureAirport !== null) {
                if (resource.aptFromCode === state.blocktimes_filterTerm.departureAirport) {
                    applyFilter = true;
                }
            }

            // if there is set no search term
            if (!state.blocktimes_filterTerm.departureAirport || state.blocktimes_filterTerm.departureAirport === null) {
                applyFilter = true;
            }

            return applyFilter;
        };

        // >>> 'filterDestinationAirport' -------------------------
        const filterDestinationAirport = (resource) => {
            let applyFilter = false;


            if (state.blocktimes_filterTerm.destinationAirport && state.blocktimes_filterTerm.destinationAirport !== null) {
                if (resource.aptToCode === state.blocktimes_filterTerm.destinationAirport) {
                    applyFilter = true;
                }
            }

            // if there is set no search term
            if (!state.blocktimes_filterTerm.destinationAirport || state.blocktimes_filterTerm.destinationAirport === null) {
                applyFilter = true;
            }

            return applyFilter;
        };

        // >>> Rebuild ------------------------------------
        state.blocktimes_blocktimes_Filtered = state.blocktimes_blocktimes.filter(resource => filterDepartureAirport(resource));
        state.blocktimes_blocktimes_Filtered = state.blocktimes_blocktimes_Filtered.filter(resource => filterDestinationAirport(resource));

    } // eo function mut_filter_Blocktimes()

};





//-----------------------------------------------------------------------------/
// #
// #    /$$$$$$             /$$     /$$
// #   /$$__  $$           | $$    |__/
// #  | $$  \ $$  /$$$$$$$/$$$$$$   /$$  /$$$$$$  /$$$$$$$   /$$$$$$$
// #  | $$$$$$$$ /$$_____/_  $$_/  | $$ /$$__  $$| $$__  $$ /$$_____/
// #  | $$__  $$| $$       | $$    | $$| $$  \ $$| $$  \ $$|  $$$$$$
// #  | $$  | $$| $$       | $$ /$$| $$| $$  | $$| $$  | $$ \____  $$
// #  | $$  | $$|  $$$$$$$ |  $$$$/| $$|  $$$$$$/| $$  | $$ /$$$$$$$/
// #  |__/  |__/ \_______/  \___/  |__/ \______/ |__/  |__/|_______/
// #
//-----------------------------------------------------------------------------/
const actions = {

    /***************************************************************************
    * Actions: 'Blocktimes', Call: Get Blocktimes
    ***************************************************************************/
    /***************************************************************************
    * Call::'/rest/humanresources/blocktimes'
    *
    * Desc:
    * Note:
    *
    */
    actn_call_getBlocktimes: (context, payload) => {

        let hdrs = '';


        // >>> Send Ajax Request --------------------------
        //Vue.prototype.$vp_m();
        axios.get('/humanresources/blocktimes')
            .then(function (response) { // 'OK'
                //Vue.prototype.$vp_um();
                hdrs = response.headers['air41-status'];
                switch (hdrs) {
                    case 'OK': // 'OK'
                        context.commit('mut_call_getBlocktimes', { payload: response.data, context: context });
                        break;
                    default: // 'ERROR'
                        Vue.prototype.$toasted.global.sdr_app_error({
                            message: response.headers['air41-error']
                        });
                        break;
                }
            })
            .catch(function (error) { // 'ERROR'
                Vue.prototype.$vp_um();
                Vue.prototype.$toasted.global.sdr_app_error({
                    message: 'Service unavailable: ' + error
                });
            });

    }, // eo function actn_call_getBlocktimes()


    /***************************************************************************
    * Actions: 'Blocktimes', Call: Create/Update Blocktimes
    ***************************************************************************/
    /***************************************************************************
    * Call::'/rest/humanresources/blocktimes'
    *
    * Desc: Create/ Update blocktimes.
    * Note:
    *
    */
    actn_call_updateCreateBlocktimes: (context, payload) => {

        let hdrs = '';


        // >>> Send Ajax Request --------------------------
        //Vue.prototype.$vp_m();
        axios.put('/humanresources/blocktimes', payload)
            .then(function (response) { // 'OK'
                //Vue.prototype.$vp_um();
                hdrs = response.headers['air41-status'];
                switch (hdrs) {
                    case 'OK': // 'OK'
                        context.commit('mut_call_updateCreateBlocktimes', { payload: response.data, context: context });
                        eventBus.$emit('blocktimewasupdatedcreated'); // emit ..
                        break;
                    default: // 'ERROR'
                        Vue.prototype.$toasted.global.sdr_app_error({
                            message: response.headers['air41-error']
                        });
                        break;
                }
            })
            .catch(function (error) { // 'ERROR'
                Vue.prototype.$vp_um();
                Vue.prototype.$toasted.global.sdr_app_error({
                    message: 'Service unavailable: ' + error
                });
            });

    }, // eo function actn_call_getBlocktimes()


    /***************************************************************************
    * Actions: 'Blocktimes', Call: Delete Blocktimes
    ***************************************************************************/
    /***************************************************************************
    * Call::'/rest/humanresources/blocktimes'
    *
    * Desc: Call: Delete Blocktime.
    * Note: Payload is 'id' (Resource Id).
    *
    */
    actn_call_deleteBlocktime: (context, payload) => {

        const url = '/humanresources/blocktimes/' + payload;
        let hdrs = '';


        // >>> Send Ajax Request --------------------------
        Vue.prototype.$vp_m();
        axios.delete(url)
            .then(function (response) { // 'OK'
                Vue.prototype.$vp_um();
                hdrs = response.headers['air41-status'];
                switch (hdrs) {
                    case 'OK': // 'OK'
                        context.commit('mut_call_deleteBlocktime', response.data);
                        Vue.prototype.$toasted.global.sdr_app_info({ // inform
                            message: 'Record was deleted.'
                        });
                        break;
                    default: // 'ERROR'
                        Vue.prototype.$toasted.global.sdr_app_error({
                            message: response.headers['air41-error']
                        });
                        break;
                }
            })
            .catch(function (error) { // 'ERROR'
                Vue.prototype.$vp_um();
                Vue.prototype.$toasted.global.sdr_app_error({
                    message: 'Service unavailable: ' + error
                });
            });

    }, // eo function actn_call_deleteBlocktime()




    /***************************************************************************
    * Actions: 'Blocktimes' - Search/Filter
    ***************************************************************************/
    /***************************************************************************
    * actn_set_filterBlocktimes_filterTerm()
    *
    * Desc: Set 'filter Terms' and 'refilter'.
    * Note:
    *
    */
    actn_set_filterBlocktimes_filterTerm: (context, payload) => {

        context.commit('mut_set_filterBlocktimes_filterTerm', payload); // save term
        context.commit('mut_filter_Blocktimes'); // rebuild

    } // eo function actn_set_filterBlocktimes_filterTerm()

};





//-----------------------------------------------------------------------------/
//-----------------------------------------------------------------------------/
//-----------------------------------------------------------------------------/
export default {
    state,
    getters,
    mutations,
    actions
};
